export interface Filters {
  Testimonial: string[]
  Technologies: string[]
  Timeline: string[]
  Budget: Array<string | null>
  Industry: string[]
  Company: string[]
}

export const oldFilters: Filters = {
  Testimonial: ["YES"],
  Technologies: [
    "8X8 CTI",
    "AWS",
    "Adobe eSign",
    "Angular",
    "Aptify",
    "AthenaOne",
    "Automated Testing",
    "CI/CD",
    "CPQ - Configure, Price, Quote",
    "CVS Caremark",
    "Cloud4J",
    "Conga",
    "Data Cloud",
    "Datorama",
    "DocuSign",
    "DynamoDB",
    "Einstein",
    "FSL - Field Service Lightning",
    "Field Service Lightning",
    "Flutter",
    "Formstack",
    "Harvest",
    "Heroku",
    "Hubspot Marketing",
    "Jitterbit",
    "Jotform",
    "KIPU",
    "LinkedIn Sales Navigator",
    "Mailchimp",
    "Marketing Cloud",
    "Material UI",
    "Microservices",
    "Microsoft Office 365",
    "Mobile Publisher",
    "Mongodb",
    "MuleSoft",
    "Nest.js",
    "NgRx",
    "Node.js",
    "Pardot",
    "QuickBooks",
    "React",
    "RootStock",
    "SF Experience Cloud",
    "Salesforce",
    "Salesforce Apex",
    "Salesforce Aura",
    "Salesforce Commerce Cloud - B2B",
    "Salesforce Experience Cloud",
    "Salesforce Financial Services Cloud",
    "Salesforce Health Cloud",
    "Salesforce Lightning",
    "Salesforce Lightning Web Components",
    "Salesforce Maps",
    "Salesforce NPSP",
    "Salesforce Revenue Cloud",
    "Salesforce Sales Cloud",
    "Salesforce Service Cloud",
    "Salesforce Shield",
    "Selenide",
    "Serverless",
    "Service Cloud Voice",
    "Ship Station",
    "Shopify",
    "Sigmund",
    "Slack",
    "Snowflake",
    "Social Studio",
    "StoreConnect",
    "Tableau",
    "Tableau CRM",
    "TaskRay",
    "Tibco Scribe - CCI for Data Migration",
    "Workato",
    "ZoomInfo",
    "Zywave",
  ],
  Timeline: [
    "12-17 Months",
    "2-4 Weeks",
    "3-4 Months",
    "4-8 weeks",
    "5-7 Months",
    "7-12 Months",
    "Managed Service",
    "Over 2 Years",
    "Over a year",
  ],
  Budget: [
    null,
    "$100,000-$150,000",
    "$150,000-$200,000",
    "$20,000-$40,000",
    "$200,000-$300,000",
    "$300,000-$450,000",
    "$40,000-$70,000",
    "$450,000-$700,000",
    "$70,000-$100,000",
    "$700,000-$1,000,000",
    ">$1,000,000",
  ],
  Industry: [
    "Agriculture & Mining",
    "Consumer Goods",
    "Education (For Profit)",
    "Energy",
    "Engineering, Construction, & Real Estate",
    "Financial Services",
    "Healthcare & Life Sciences",
    "High Tech",
    "Manufacturing",
    "Media & Entertainment",
    "Nonprofit",
    "Professional Services",
    "Retail",
    "Supply Chain & Logistics",
    "Travel, Transportation, & Hospitality",
  ],
  Company: [
    "Acquis Consulting Group LLC",
    "Addax",
    "Agency73",
    "Avenga",
    "Bigger Boat Consulting",
    "Carabiner Group",
    "Cloud Pathfinder LLC",
    "CloudMasonry",
    "Coastal",
    "DoubleTrack",
    "Edge",
    "Endiem",
    "Flok Consulting",
    "HebronSoft",
    "Incapsulate",
    "Madison Ave Consulting",
    "Orion Global Solutions",
    "Platinum Cubed",
    "SaltClick",
    "Simplus",
    "StoreConnect",
    "Third Republic",
    "Valence",
    "Wise Wolves Consultancy",
    "louie inc",
  ],
}
